import { error } from 'services/graphql/fragments/Fragments';
import { gql } from 'urql';

export const DeactivateOffer = gql`
  mutation DeactivateOffer($input: DeactivateOfferInput!) {
    deactivateOffer(input: $input) {
      ... on DeactivateOfferSuccess {
        __typename
        id
        deactivatedOfferId
        successTitle: title
        displayAnalytics {
          __typename
          name
          properties {
            __typename
            key
            value
          }
        }
      }
      ... on DeactivateOfferError {
        __typename
        ...error
      }
    }
  }
  ${error}
`;

export default DeactivateOffer;
